/** @jsx jsx */
import { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { jsx } from '@atlaskit/css';
import { Collapsible } from '@atlassian/jira-platform-collapsible/src/index.tsx';
import type { SaveResetViewSettingsButtonCollapsible$key } from './__generated__/SaveResetViewSettingsButtonCollapsible.graphql';
import { SaveResetViewSettingsButtonUI } from './SaveResetViewSettingsButtonUI.tsx';

type Props = {
	onReset: () => void;
	viewFragment: SaveResetViewSettingsButtonCollapsible$key;
	jql: string;
};

export const SaveResetViewSettingsButtonCollapsible = memo(
	({ onReset, viewFragment, jql }: Props) => {
		const viewMetadata = useFragment(
			graphql`
				fragment SaveResetViewSettingsButtonCollapsible on JiraIssueSearchViewMetadata {
					...SaveResetViewSettingsButtonUI
					isViewConfigModified(settings: $settings)
				}
			`,
			viewFragment,
		);

		return (
			<Collapsible
				animationDuration={260}
				direction="horizontal"
				isExpanded={viewMetadata.isViewConfigModified ?? false}
			>
				<SaveResetViewSettingsButtonUI jql={jql} onReset={onReset} viewFragment={viewMetadata} />
			</Collapsible>
		);
	},
);
